const DocQueryFields = [
    {
        name: '#',
        code: '_seq_',
        column: true,
        sortable: false,
        defaultFilter: false,
        width: 70
    },
    {
        name: '标题',
        code: 'title',
        column: true,
        defaultFilter: true,
        listFilter: true
    },
    {
        name: '模板',
        code: 'templateName',
        column: true,
        defaultFilter: true,
        listFilter: true,
        width: 200
    },
    {
        name: '主送机关',
        code: 'toOrg',
        column: true,
        sortable: false,
        align: 'left',
        width: 200
    },
    {
        name: '发文字号',
        code: 'docNo',
        column: true,
        sortable: false,
        align: 'left',
        width: 200
    },
    {
        name: '抄送机关',
        align: 'left',
        code: 'ccOrg',
        defaultFilter: true,
        sortable: false,
        listFilter: true,
        column: true,
        width: 200

    }
];
export default DocQueryFields;
